var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "nativewind/jsx-runtime";
import React from 'react';
import { StyleSheet, TextInput, View, } from 'react-native';
import SearchIcon from '@/assets/icon/ic_search.svg';
import { color } from '@/constant/color';
import { font } from '@/constant/font';
export const SccInput = (_a) => {
    var { noIcon = false, placeholder = '', setValue = () => { }, style = {} } = _a, props = __rest(_a, ["noIcon", "placeholder", "setValue", "style"]);
    return (_jsxs(View, { style: [styles.search, style], children: [!noIcon && (_jsx(SearchIcon, { width: 20, height: 20, style: styles.searchIcon })), _jsx(TextInput, Object.assign({ style: styles.searchText, placeholder: placeholder, placeholderTextColor: color.gray70, onChangeText: text => setValue(text) }, props))] }));
};
const styles = StyleSheet.create({
    search: {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        borderRadius: 20,
        backgroundColor: color.gray20,
        paddingHorizontal: 24,
        paddingVertical: 20,
    },
    searchIcon: {
        marginRight: 20,
    },
    searchText: {
        flex: 1,
        color: color.black,
        fontFamily: font.pretendardMedium,
        fontSize: 18,
        marginTop: -1,
        paddingVertical: 0,
    },
});
